export default __webpack_public_path__ + "static/media/crown.b23d027c.png";